import { Button, Input, List } from "antd";
import { useDispatch, useSelector } from 'react-redux';
import Rule from "../../Classes/Rule";
import { pickAFileSliceDispatch, ruleModalSliceDispatch, ruleViewerSliceDispatch } from "../../Constants/ReduxConstants";
import { ReduxHelpers } from "../../Helpers/ReduxHelpers";
import RuleModal from ".././RuleModal/RuleModal";

const RuleViewer = () => {
    const currentRules = useSelector((state: any) => state.pickAFile.rules);
    const currentAddressStart = useSelector((state: any) => state.pickAFile.addressStart);

    const addModal = useSelector((state: any) => state.ruleViewer.addModal);
    const editModal = useSelector((state: any) => state.ruleViewer.editModal);

    const ruleSearchResults = useSelector((state: any) => state.ruleViewer.ruleSearchResults);

    const dispatch = useDispatch()

    const { CreateContentsFromStates } = ReduxHelpers();

    function DeleteARule(ruleIdToDelete, updateState: boolean = true) {
        let filteredRules = currentRules.filter(rule => rule.event.type != ruleIdToDelete);

        if (updateState) {
            dispatch({ type: pickAFileSliceDispatch.setRules, payload: filteredRules })
            dispatch({ type: ruleViewerSliceDispatch.setRuleSearchResults, payload: filteredRules })
            CreateContentsFromStates({ rules: filteredRules });
        }

        return filteredRules;
    }

    let maxIndex = currentAddressStart
    if (currentRules?.length > 0) {
        maxIndex = Math.max(...currentRules.map(o => o.event.type))
        maxIndex++
    }

    const HandleDelete = (event) => {
        DeleteARule(event.currentTarget.id, true)
    }

    const onRuleSearchChange = (event) => {
        const searchValue = event.target.value.toLowerCase();

        if (searchValue === "") {
            dispatch({ type: ruleViewerSliceDispatch.setRuleSearchResults, payload: currentRules });
        } else {
            const filtered = currentRules.filter(rule =>
                rule.name?.toLowerCase().includes(searchValue) ||
                rule.conditions.all?.some(a => a.fact.toLowerCase().includes(searchValue)) ||
                rule.conditions.any?.some(a => a.fact.toLowerCase().includes(searchValue))
            );
            dispatch({ type: ruleViewerSliceDispatch.setRuleSearchResults, payload: filtered });
        }
    }

    const AddModal = () => {
        dispatch({ type: ruleViewerSliceDispatch.setAddModal, payload: true })
        dispatch({ type: ruleViewerSliceDispatch.setEditModal, payload: false })
        dispatch({ type: ruleModalSliceDispatch.setOpen, payload: true });
    }

    const EditModal = () => {
        dispatch({ type: ruleViewerSliceDispatch.setEditModal, payload: true })
        dispatch({ type: ruleViewerSliceDispatch.setAddModal, payload: false })
        dispatch({ type: ruleModalSliceDispatch.setOpen, payload: true });
    }

    const allRules =
        <div>
            <Input style={{ width: '149px' }} id="ruleSearchResults" placeholder='Search...' onChange={onRuleSearchChange} />
            <br />
            <br />
            <Button onClick={() => {
                AddModal();
                dispatch({ type: ruleModalSliceDispatch.setRuleToAdd, payload: new Rule()});
                dispatch({ type: ruleViewerSliceDispatch.setCurrentRule, payload: new Rule()});
                dispatch({ type: ruleModalSliceDispatch.setRuleToAddEventType, payload: maxIndex.toString() });
                dispatch({ type: ruleModalSliceDispatch.setRuleToAddConditionsAll, payload: [] });
                dispatch({ type: ruleModalSliceDispatch.setRuleToAddConditionsAny, payload: [] });
                dispatch({ type: ruleModalSliceDispatch.setRuleToAddName, payload: "" });
                dispatch({ type: ruleViewerSliceDispatch.setIndexOverride, payload: maxIndex });
            }}>
                Add new Rule
            </Button>
            {addModal && <RuleModal />}
            {editModal && <RuleModal />}
            <List
                dataSource={ruleSearchResults?.sort((a: any, b: any) => a.event.type > b.event.type ? 1 : -1)}
                renderItem={(currentRule: any, index: number) => (
                    <div key={"allRule_" + index}>
                        <List.Item key={"rule_" + index}>
                            <Button onClick={() => {
                                EditModal();
                                dispatch({ type: ruleModalSliceDispatch.setRuleToAdd, payload: currentRule });
                                dispatch({ type: ruleViewerSliceDispatch.setCurrentRule, payload: currentRule });
                                dispatch({ type: ruleModalSliceDispatch.setRuleToAddEventType, payload: currentRule.event.type ? currentRule.event.type : currentAddressStart + index });
                                dispatch({ type: ruleModalSliceDispatch.setRuleToAddConditionsAll, payload: currentRule.conditions.all });
                                dispatch({ type: ruleModalSliceDispatch.setRuleToAddConditionsAny, payload: currentRule.conditions.any });
                                dispatch({ type: ruleModalSliceDispatch.setRuleToAddName, payload: currentRule.name });
                                dispatch({ type: ruleViewerSliceDispatch.setIndexOverride, payload: currentAddressStart + index });
                            }}>
                                Edit
                            </Button>
                            &nbsp;
                            <Button id={currentRule.event.type} onClick={HandleDelete}>Delete</Button>
                            &nbsp;
                            {currentRule.event.type}
                            {currentRule.conditions.all &&
                                currentRule.conditions.all.map((rule, index) =>
                                    <List.Item>
                                        {index > 0 ? " AND " : ""} {rule.fact} - {rule.operator} - '{rule.value}'
                                    </List.Item>)
                            }
                            {currentRule.conditions.any &&
                                currentRule.conditions.any.map((rule, index) =>
                                    <List.Item>
                                        {index > 0 ? " OR " : ""} {rule.fact} - {rule.operator} - '{rule.value}'
                                    </List.Item>)
                            }
                        </List.Item>
                    </div>
                )}
            />
        </div>

    return (<div>{allRules}</div>)

}

export default RuleViewer;